<template>
  <div class="confirmation-upload-view" v-loading="loading"
       :class="{'is-doc-upload': true}"
       @dragover.prevent="uploadDragOver">
    <div class="jp-confirmation-upload-content"
         :class="{'is-seal': isSeal}">
      <template>
        <p class="jp-delivery-tooltip" :class="{'is-dark': effect === 'dark'}">为避免出现程序性错误，系统将自动对您文件名中的隐藏字符进行删除，请您知悉！</p>
        <div class="fd-upload-view" @click.stop="uploadClick" @dragover.stop.prevent="()=>{}">
          <img src="@/assets/image/case-import/ic_upload.png">
          <div class="el-upload__text"><span>点击上传</span></div>
          <input style="display: none;" type="file" ref="uploadInput" @change="uploadChange" v-if="isShowUploadInput"
                 @blur="uploadBlur"
                 :multiple="isSingleCase"
                 :webkitdirectory="isSingleCase&&uploadSelect=='2'">
        </div>
      </template>
    </div>
  </div>

</template>

<script>
import {confirmationImport} from '@/assets/js/api';
import {mapState} from 'vuex';

export default {
  name: 'confirmation-upload-view',
  props: {
    isSingleCase: {// 是否只选择一个案子
      type: Boolean,
      default: false,
    },
    // 列表批量上传必要参数
    queryParams: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 主题 light / dark
    effect: {
      type: String,
      default: 'light'
    }
  },
  data() {
    return {
      isSeal: false,
      currentMediateId: '', // 单个案件材料批量上传必要参数
      loading: false,
      showLayer: false,
      uploadSelect: '1',
      uploadRecover: '1', // 选择全部覆盖或者跳过，默认跳过
      isShowUploadInput: true,
      // 是否自动送达文书
      deliveryFlag: '',
    };
  },
  computed: {...mapState({confirmationExport: state => state.longTask.confirmationExport})},
  watch: {
    isSeal(n) {
      if (!n) {
        // 初始化
        this.deliveryFlag = '';
      }
    }
  },
  methods: {

    /**
     *拖拽上传
     */
    uploadDragOver(e) {
      if (!this.showLayer) {
        this.showLayer = true;
      }
      console.log('uploadDragOver', e);
    },

    /**
     * 点击上传(文件／文件夹)
     */
    uploadClick(e) {
      this.$refs.uploadInput.click();
    },

    uploadBlur(e) {
      console.log('uploadBlur', e);
    },

    async uploadChange(e) {
      this.$bus.$emit('uploadChange');
      const files = e.target.files;
      console.log('uploadChange', e);
      const fileObj = files[0];
      if (!['xlsx', 'xls'].includes(this.getSuffix(fileObj.name).toLowerCase())) {
        return this.$message.error('请选择xlsx、xls类型的文件导入');
      }
      if (fileObj.size === 0) {
        return this.$message.error('上传文件的大小必须大于0KB');
      }
      if (fileObj.size > 20 * 1024 * 1024) {
        return this.$message.error('上传文件的大小不能大于20M');
      }
      const fd = new FormData();
      fd.append('file', fileObj);
      confirmationImport(fd)
        .then(res => {
          if (res.code === 200) {
            this.$store.commit('SET_CONFIRMATION_EXPORT', {
              key: 'id',
              value: res.data
            });
            this.$store.commit('SET_CONFIRMATION_EXPORT', {
              key: 'status',
              value: 2
            });
          } else if (res.code === 403 && res.msg) {
            this.$message.error(res.msg);
          }
        })
        .catch(err => {

        });
    },
    getSuffix(str) {
      const suffix = str.split('.')
        .reverse()[0];
      return suffix;
    },
    clearFile() {
      this.isShowUploadInput = false;
      this.$nextTick(() => {
        this.isShowUploadInput = true;
      });
    },
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.confirmation-upload-view {
  display: flex;
  flex-direction: column;
  background: #fff;
}

.jp-confirmation-upload-content {
  padding: 24px 40px 40px;
  width: 100%;

  &.is-seal {
    padding-bottom: 32px;
  }
}

.is-doc-upload {
  max-height: 360px;
}

.fd-upload-view {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
  padding: 62px 0;
  width: 100%;
  max-height: 256px;
  border-radius: 2px;
  border: 1px solid #eee;
  cursor: pointer;

  > img {
    width: 48px;
    height: 53px;
  }

  .el-upload__text {
    margin-top: 5px;
    color: #999;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    line-height: 14px;

    > span {
      color: #274ea4;
    }
  }

  .download-btn {
    margin-top: 24px;
    width: 216px;
    height: 36px;
    border-radius: 2px;
    border: 1px solid #eee;
  }
}

.fd-upload-select {
  display: flex;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 8px;

  > span {
    margin-right: 48px;
    color: #999;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    line-height: 14px;
    white-space: pre;
  }
}

.fd-upload-seal {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  margin-bottom: 16px;

  > button {
    width: 105px;
    height: 40px;
    color: #999;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 20px;
    border: 1px solid #eee;
    background: #f7f8fa;
    cursor: pointer;
  }

  > button:active {
    background: rgba(238, 238, 238, 0.8);
  }

  .active {
    color: #323233;
    border: 1px solid #eee;
    border-bottom: 0;
    background: #fff;
  }

  > div {
    flex: 1;
    width: 287px;
    height: 1px;
    background: #eee;
  }
}

.fd-drag-layer {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  color: #fff;
  font-size: 24px;
  font-family: MicrosoftYaHei;
  line-height: 24px;
  background: rgba(0, 0, 0, 0.64);
  cursor: default;
}

.upload-radio {
  color: #333;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 14px;

  .el-radio__label {
  }
}

.file-cover {
  margin-right: 20px;
}

.jp-confirmation-bottom {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 40px;
  height: 68px;
  border-radius: 0 0 4px 4px;
  border-top: 1px solid #eee;

  &.is-dark {
    border-top: 1px solid #404040;
  }

  .el-button {
    min-width: 128px;
  }
}
.jp-delivery-tooltip {
  margin-bottom: 12px;
  font-size: 14px;
  color: #333;
  line-height: 21px;
  user-select: none;
  word-break: keep-all;
  &.is-dark {
    color: #fff;
  }
  span {
    color: #E28103;
    font-weight: bold;
  }
}
</style>
